import { render, staticRenderFns } from "./MonContact.vue?vue&type=template&id=580f82c5&"
import script from "./MonContact.vue?vue&type=script&lang=js&"
export * from "./MonContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports